export enum Event {
    gigOrderOptionsOpened = 'gigOrderOptionsOpened',
    onboardingQuestionnaireBuyerFinish = 'onboardingQuestionnaireBuyerFinish',
    onboardingQuestionnaireCompanySizeNext = 'onboardingQuestionnaireCompanySizeNext',
    onboardingQuestionnaireNotOnlyPersonalUseNext = 'onboardingQuestionnaireNotOnlyPersonalUseNext',
    onboardingQuestionnaireBuyerNext = 'onboardingQuestionnaireBuyerNext',
    contactMeClicked = 'contact_me_clicked',
    searched = 'searched',
}
